module.exports = __webpack_public_path__ + "img/contact-indigator.e4711c71.png";